import Form from "../../../Components/Form"
import { useState, useEffect } from "react"
import { updateEntryBalance } from "../../../Model/RegisterEntries"
import NumberInput from "../../../Components/Form/NumberInput"
import Text from "../../../Components/Text"
export const CashAccountingForm = ({ item, afterAction }) => {
    const [isBalance, setIsBalance] = useState(0)

    useEffect(() => {
        if (item) {
            setIsBalance(item.startAmount || 0)
        }
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()

        await updateEntryBalance(isBalance, item.offlineId, true, item)
        afterAction()
    }
    return (
        <Form onSubmitAction={handleSubmit} submitButtonText={"Kasse Abrechnen"}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}> {`Kasse von ${item.user.firstName} abrechnen`}</Text>
            <Text type="main" classNames={"flex text-center justify-center"}> {`Kasseninhalt SOLL ${item.finalAmount}`}</Text>
            <NumberInput
                id={"isBalance"}
                label="Kasseninhalt IST"
                action={(e) => setIsBalance(e.target.value)}
                attribute={isBalance}
                min={0} step="0.01"
                required={true}
            />
        </Form>
    )
}